import { ROUTES } from 'constants/routes';
import { useAuthenticatedAxios } from 'hooks/useAuthenticatedAxios';
import { useQuery } from 'react-query';
import { ErrorResponse } from 'types/network';
import { useMswManager } from 'lib/util/useMswManager';
import { HrznGatewayMswBuilder } from 'stories/HrznGatewayMswBuilder';

export interface CommentType {
  encounterHeaderCommentTypeID: number;
  encounterHeaderCommentType: string;
}

// Mock data for development and testing
const mockCommentTypes: CommentType[] = [
  {
    encounterHeaderCommentTypeID: 1,
    encounterHeaderCommentType: 'Clinical Documentation'
  },
  {
    encounterHeaderCommentTypeID: 2,
    encounterHeaderCommentType: 'Billing Information'
  },
  {
    encounterHeaderCommentTypeID: 3,
    encounterHeaderCommentType: 'Patient Follow-up'
  },
  {
    encounterHeaderCommentTypeID: 4,
    encounterHeaderCommentType: 'Insurance Verification'
  }
];

export const usePartnerGetMyEncounterCommentTypes = () => {
  const Axios = useAuthenticatedAxios();

  // Setup MSW mock
  useMswManager(
    HrznGatewayMswBuilder.create().get(ROUTES.PartnerGetMyEncounterCommentTypes, {
      data: mockCommentTypes
    })
  );

  return useQuery<CommentType[], ErrorResponse>(
    [ROUTES.PartnerGetMyEncounterCommentTypes],
    async () => {
      const { data } = await Axios({
        method: 'get',
        url: `/?route=${ROUTES.PartnerGetMyEncounterCommentTypes}`
      });
      return data;
    },
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false
    }
  );
};
